export default __webpack_public_path__ + "static/media/OpenSans-Italic-webfont.0bd0c2ca.woff";